import React from 'react';
import {Grid} from '@mui/material';
import AutoField, {ActionType} from '../AutoForm/AutoFieldNew';

export const SimpleInvestmentPhilosophyFields: React.FC = () => {
  return (
    <>
      <Grid item xs={4} p={1} />
      <Grid item xs={4} p={1}>
        <AutoField
          field={{
            id: 'giaHasLiquidityNeeds',
            fullWidth: true,
            label: 'GIA Liquidity Needs',
            type: ActionType.checkboxToggle,
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={4} p={1}>
        <AutoField
          field={{
            id: 'pensionHasLiquidityNeeds',
            fullWidth: true,
            label: 'Pension Liquidity Needs',
            type: ActionType.checkboxToggle,
            readOnly: true,
          }}
        />
      </Grid>
    </>
  );
};
